import { Button, Col, Divider, Row } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const SubmitAndPrintForm = (props) => {
  const [salesLineData, setSalesLineData] = useState([]);
  const salesState = useSelector((state) => state.salesState);

  useEffect(() => {
    if (salesState.status === 'success') {
      setSalesLineData(salesState.data.salesLines);
    }
  }, [salesState.status]);

  return (
    <div>
      <div style={{ textAlign: 'center', padding: '20px 0' }}>
        <img src='/path-to-shop-icon.png' alt='Shop Icon' style={{ width: '60px' }} />
        <h2>POS</h2>
        <Divider />
        <Row justify='space-between'>
          <Col>Date:</Col>
          <Col>{moment(salesState.data.createdOn).format('DD-MM-YYYY')}</Col>
        </Row>
        <Row justify='space-between'>
          <Col>Location:</Col>
          <Col>warehouse Location Address</Col>
        </Row>
        <Row justify='space-between'>
          <Col>Phone:</Col>
          <Col>1234567888</Col>
        </Row>
        <Row justify='space-between'>
          <Col>Customer:</Col>
          <Col>Customer Name</Col>
        </Row>
        <Divider />
        {salesLineData.map((line, index) => (
          <Row key={index} justify='space-between'>
            <Col>
              {line.productName} ({line.productCode})
            </Col>
            <Col>
              {line.orderQTY || 0} Pc X ${line.cost || 0} = ${line.extendedPrice || 0}
            </Col>
          </Row>
        ))}
        <Divider />
        <Row justify='space-between'>
          <Col>Total Amount:</Col>
          <Col>${salesState.data.totalAmount}</Col>
        </Row>
        <Divider />
        <Row justify='space-between'>
          <Col>Paid By:</Col>
          <Col>{salesState.data.paymentType}</Col>
        </Row>
        <Row justify='space-between'>
          <Col>Change Return:</Col>
          <Col>${salesState.data.changeAmount || '0.00'}</Col>
        </Row>
        <Divider />
        <div style={{ textAlign: 'center', margin: '20px 0' }}>
          <img src='/path-to-barcode.png' alt='Barcode' style={{ width: '150px' }} />
          <p>{salesState.data.salesTransNo}</p>
        </div>
        <div style={{ marginTop: '20px' }}>
          <Button
            onClick={() => {
              window.print();
            }}
            type='primary'
            style={{ marginRight: '10px' }}
          >
            Print
          </Button>
          <Button>Close</Button>
        </div>
      </div>
    </div>
  );
};

export default SubmitAndPrintForm;
